<template>
  <div class="bdg-map w-full">
    <img
      alt="Google Map of Contract address"
      :src="staticMapImage"
      v-if="staticMapImage"
    />
  </div>
</template>

<script>
// const tailwind = require("../../tailwind.config");

import { Place } from "../models/Place";

export default {
  name: "BdgMap",
  props: {
    place: Place
  },
  data() {
    return {
      isMounted: false,
      googleApiKey: "AIzaSyC1wabMDHt2jboca4WguP6Eji-YQTZy-qQ"
    };
  },
  computed: {
    containerHeight() {
      if (this.isMounted) {
        const rect = this.$el.getBoundingClientRect();
        return Math.floor(rect.height);
      }
      return 200;
    },
    containerWidth() {
      if (this.isMounted) {
        const rect = this.$el.getBoundingClientRect();
        return Math.floor(rect.width);
      }
      return 300;
    },
    latLng() {
      return this.place && this.place.lat && this.place.lng
        ? `${this.place.lat},${this.place.lng}`
        : null;
    },
    staticMapImage() {
      if (this.latLng) {
        return `https://maps.googleapis.com/maps/api/staticmap?center=${this.latLng}&zoom=13&size=${this.containerWidth}x${this.containerHeight}&maptype=roadmap
&markers=${this.latLng}
&key=${this.googleApiKey}`;
      }
      return undefined;
    }
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style scoped></style>
